import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { ReadViewContainer } from '../../../../../../../common/ui/goals/styled';
import { Row } from '../../../../../../../common/ui/styled';
import { useSLAHierarchicalGoalsEnabled } from '../../../../../../../controllers/enable-sla-hierarchical-goals';
import messages from './messages';

type Props = {
	defaultGoal: boolean;
	jqlQuery: string;
	goalId?: string;
	metricId?: number;
	areSubGoalsPresent?: boolean;
} & Intl;

export const JqlFieldComponent = ({
	jqlQuery,
	defaultGoal,
	goalId = '',
	metricId = 0,
	areSubGoalsPresent = false,
	intl: { formatMessage },
}: Props) => {
	const [{ isPriorityNameChanged }] = useSLAHierarchicalGoalsEnabled();
	return (
		// @ts-expect-error - TS2739 - Type '{ children: Element; }' is missing the following properties from type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { editMode: boolean; placeholder: any; }, any>>': placeholder, editMode
		<ReadViewContainer>
			<JqlViewContainer>
				{defaultGoal ? formatMessage(messages.allRemainingIssues) : jqlQuery}
				{
					// @ts-expect-error - TS7053
					isPriorityNameChanged?.[metricId]?.[goalId] && (
						<Tooltip content={formatMessage(messages.errorTooltip)} position="top">
							<Button
								iconBefore={
									<ErrorIcon
										primaryColor={token('color.icon.danger', colors.R500)}
										size="medium"
										label={formatMessage(messages.errorTooltip)}
									/>
								}
								appearance="subtle"
							/>
						</Tooltip>
					)
				}
				{jqlQuery.toLowerCase().includes('priority') && areSubGoalsPresent && (
					<Tooltip
						content={formatMessage(messages.warningWhenPriorityIsPresentInJqlWithSubGoals)}
						position="top"
					>
						<Button
							iconBefore={
								<WarningIcon
									primaryColor={token('color.icon.warning', colors.Y500)}
									size="medium"
									label=""
								/>
							}
							appearance="subtle"
						/>
					</Tooltip>
				)}
			</JqlViewContainer>
		</ReadViewContainer>
	);
};

export const JqlViewField = injectIntl(JqlFieldComponent);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const JqlViewContainer = styled(Row)({
	padding: token('space.100', '8px'),
	alignItems: 'center',
});
